module.exports = __webpack_public_path__ + "static/media/Tram.22880d43.mp3";